module.exports = __webpack_public_path__ + "static/media/facebook.06f64e3c.png";